// @flow

import {useContext} from 'react';
import {LocalesContext} from '../../../../utils/locales';
import React from 'react';
import {
    AppleLink,
    GoogleLink,
    Line,
    PhoneContainer,
    PhoneImg,
    StyledDonut,
    Title
} from './StyledFloatingMobile';
import {FlexRow} from '../../../../StyledUtils';
import {APP_STORE, GOOGLE_PLAY_STORE} from '../../../../utils/const';
import {getStorageKey, MOBILE, MOBILE_CTA_KEY} from '../../FloatingAddWOT';
import {Circle, CloseIcon} from '../../StyledFloatingAddWOT';

type IFloatingMobileProps = {
    pageTrackName: string,
    onClose: (source: string) => void,
}

export const FloatingMobile = ({pageTrackName, onClose}: IFloatingMobileProps): any => {
    const {translate} = useContext(LocalesContext);
    const onMobileStoreClick = (label: string) => {
        window.localStorage.setItem(getStorageKey(MOBILE_CTA_KEY, pageTrackName), 'true');
        onClose(MOBILE);
    };
    return (
        <React.Fragment>
            <Circle>
                <PhoneContainer>
                    <PhoneImg />
                    <StyledDonut />
                </PhoneContainer>
            </Circle>
            <CloseIcon onClick={(): void => onClose(MOBILE)} />
            <Title>{translate('components.floating.add.wot.mobile.title')}</Title>
            <Line>{translate('components.floating.add.wot.mobile.line1')}</Line>
            <Line>{translate('components.floating.add.wot.mobile.line2')}</Line>
            <Line>{translate('components.floating.add.wot.mobile.line3')}</Line>
            <FlexRow>
                <GoogleLink href={GOOGLE_PLAY_STORE.replace('WotWebsite', pageTrackName + 'Frame')} target="_blank" onClick={(): void => onMobileStoreClick('Android')} />
                <AppleLink href={APP_STORE.replace('DownloadB', pageTrackName + 'Frame')} target="_blank" onClick={(): void => onMobileStoreClick('iOS')} />
            </FlexRow>
        </React.Fragment>
    );
};
